/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Auto_Time_Cps_LabelInputs */



/**
* | output |
* | --- |
* | "Calculate timing by characters per second" |
*
* @param {Context_Menu_Auto_Time_Cps_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_auto_time_cps_label = /** @type {((inputs?: Context_Menu_Auto_Time_Cps_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Auto_Time_Cps_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Calculer le minutage par caractères par seconde")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitmessung in Zeichen pro Sekunde berechnen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Calcola il tempo in caratteri al secondo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Рассчитать время в символах в секунду.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Calcular el tiempo por caracteres por segundo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按每秒字符数计算计时")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1秒あたりの文字数でタイミングを計算する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रति सेकंड अक्षरों के आधार पर समय की गणना करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Calcule o tempo por caracteres por segundo.")
	return /** @type {LocalizedString} */ ("Calculate timing by characters per second")
});